import { isFeedbackQuestionType } from '@oneclick/react-lemonade-editor';
import { useEffect, useState } from 'react';

function getContentData(assessment) {
  if (assessment?.content_data) {
    if (typeof assessment.content_data === 'string') {
      try {
        return JSON.parse(assessment.content_data);
      } catch (error) {
        console.error('Error parsing assessment.content_data:', error);
        return assessment;
      }
    }
    return assessment.content_data;
  }
  return assessment;
}

export default function useMintFeedback({ assessment }) {
  const [isMintFeedback, setIsMintFeedback] = useState(false);

  useEffect(() => {
    const contentData = getContentData(assessment);
    let isFeedback = false;

    if (contentData) {
      const metadataName = contentData?.metadata?.name || contentData?.items?.[0]?.data?.metadata?.name || contentData?.items?.[0]?.metadata?.name;

      if (metadataName) {
        isFeedback = isFeedbackQuestionType(metadataName);
      }
    }

    setIsMintFeedback(isFeedback);
  }, [assessment]);

  return {
    isMintFeedback,
  };
}
